import { render } from "./MobileKonvaEditor.vue?vue&type=template&id=c97b4fa2&scoped=true"
import script from "./MobileKonvaEditor.vue?vue&type=script&lang=js"
export * from "./MobileKonvaEditor.vue?vue&type=script&lang=js"

import "./MobileKonvaEditor.vue?vue&type=style&index=0&id=c97b4fa2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c97b4fa2"]])

export default __exports__